import { createMuiTheme } from "@material-ui/core";
import { blue, grey } from '@material-ui/core/colors';
import { FONT_SIZE_BASE } from "../contexts/ThemeContext";

export const LightTheme = (fontSize = FONT_SIZE_BASE) => {

  return createMuiTheme({
    palette: {
      primary: {
        main: '#1351b4',
        light: '#5e92f3',
        dark: '#003c8f',
        contrastText: '#FFF',
      },
      corTexto: '#4d7aa1',
      corTitulo: '#4d7aa1',   
      corIcone: '#1351b4',   
      corIcone2: '#fff',
      secondary: {
        main: grey[700],
        light: grey[600],
        dark: grey[800],
        contrastText: '#777',
        inputColor: '#636363'
      },
      background: {
        paper: '#FFFFFF',
        default:  '#f8f8f8',
        iconContrast: '#FFF',
        iconContrastSecondary: '#1351b4', 
        colorContrast: '#FFF',
        colorButtonHover: '#D9E3F3'
      },
    },
    web: {
      LoginImpl: {
        upper: {
          background: '#ffffff'
        }
      }
    },
    apps: {
      avaliacao: {
        color: '#333',
        tooltip: {
          color: '#ffffff',
          backgroundColor: '#1351b4',
        }
      },
      autenticidade: {
        template: {
          VerificarAutenticidade: {
            link: {
              color: '#1351b4',
            },
          },
          ComoUsar: {
            span: {
              border: '2px solid #168821',
            },
          }
        }
      },
      carteira: {
        imageDiv: {
          border: '2px dashed #1351B4'
        },
      },
      certificadoDeficiencia: {
        CertificadoDeficiencia: {
          text: {
            color: '#4d7aa1'
          }
        },
      },
      declaracaoAtividade: {
        DeclaracaoAtividade: {
          text: {
            color: '#4d7aa1'
          }
        }
      },
      extratoBeneficio: {
        ExtratoBeneficio: {
          root: {
            backgroundColor: '#FFFFFF',
          },
          label: {
            color: '#333333'
          },
          situacao:{
            color: '#333333'
          },
          text: {
            color: '#4d7aa1'
          },
          textNumero: {
            color: '#1351b4'
          },
          icone: {
            color: '#1351b4'
          }
        }
      },
      extratoIR: {
        SelecaoAnoBeneficio: {
          label: {
            color: '#333333'
          },
          selectYear: {
            color: '#1351B4'
          }
        }
      },
      extratoPrevidenciario: {
        template: {
          MeuInssVinculoExpansionPanel: {
            nome: {
              color: '#1351B4'
            },
            codigoEmpregador: {
              color: '#333333'
            }
          },
          extratos: {
            LegendaIndicadores: {
              text: {
                color: '#4d7aa1'
              },
              titulo: {
                color: 'rgb(69, 125, 209)',
              },
            }
          }
        }
      },
      hiscre: {
        ResultadoHiscre: {
          rubricas: {
            backgroundColor: '#FFFFFF',
          }
        }
      },
      meusBeneficios: {
        PaginaBeneficio: {
          detalhesBeneficios: {
            color: '#457dd1'
          },
          titulo:{
            color: '#333333'
          }
        }
      },
      nadaConsta: {
        NadaConsta: {
          root: {
            backgroundColor: '#fff'
          },
          text: {
            color: '#4d7aa1'
          }
        },
      },
      notificacao: {
        Notificacoes: {
          root: {
            backgroundColor: '#FFFFFF',
          },
          footer: {
            color: '#333333'
          },
          subHeader: {
            color: '#79797e',
            backgroundColor: '#ececec',
          },
          containerTitulo: {
            color: '#333333'
          },
          containerTituloMensagem: {
            color: '#333333'
          },
          labelConteudoTitulo: {
            color: '#333333'
          },
          containerMensagem: {
            color: '#333333'
          },
          notificacaoNaoLida: {
            color: '#333333'
          },
          labelConteudoData: {
            color: '#333333'
          },
          labelConteudoMensagem: {
            color: '#333333'
          },
          labelCaixaSemNotificacao: {
            color: '#333333'
          }
        }
      },
      requerimentos: {
        templates: {
          CardRequerimento: {
            nameService: {
              color: '#1351B4',            
            }
          },
          ShowRequerimentos: {
            titulo: {
              color: '#333'
            }
          }
        }
      },
      simulador: {
        public: {
          template: {
            CardVinculo: {
              simulacaoCardNome: {
                color: '#565656'
              },
              simulacaoCardData: {
                color: '#565656'
              }
            }
          }
        },
        template: {
          FiliadoInfo: {
            box: {
              color: '#9E9E9E',
              backgroundColor: '#ececec'
            },
            value: {
              color: '#303030'
            },
            selected: {
              color: 'white',
              backgroundColor: '#2B74E9 !important',
              border: '1px solid #2B74E9 !important'
            }
          },
          PainelDeDireitoWeb: {
            gridSimulacaoNome: {
              color: '#555555'
            },
            simulacaoPossuiDireitoSim: {
              color: '#168821'
            },
            simulacaoPossuiDireitoNao: {
              color: '#E60000'
            }
          },
          ResultadoCompleto: {
            header: {
              color: '#000',
              backgroundColor: '#ECECEC'
            },
            detalhes: {
              label: {
                borderBottom: '1px solid #000',
                span: {
                  background: '#fff'
                }
              }
            }
          },
          TempoServicoInfo: {
            box: {
              color: '#9E9E9E',
              backgroundColor: '#ececec'
            },
            value: {
              color: '#303030'
            }
          },
        },
        Empregos: {
          titulo: '#457dd1'
        }
      },
      simuladoEmprestimo:{
        color:"#333",
        linkColor:"#1351b4",
      },
      sobre: {
        Sobre: {
          mailSuporte: {
            color: 'black'
          }
        },
      }
    },
    painel: {
      home: {
        greetingsBox: {
          color: "#333333"
        }
      },
      Footer: {
        footer: {
          background: '#0C326F',
        }
      },
      component: {
        dashboard: {
          template: {
            List: {
              root: {
                backgroundColor: '',
                color: '#333333'
              },
              title: {
                color: blue[600],
              }
            },
            MiSearch: {
              searchContainer: {
                i: {
                  color: '#1351B4'
                },
                borderColor: '#1E88E5'
              },
              suggestion: {
                hover: {
                  backgroundColor: '#F6F9FD',
                  borderLeft: '4px solid #1E88E5'
                }
              }
            },
            MainBar: {
              appBarDesktop: {
                span: {
                  borderLeft: '1px solid #C9C9C9'
                }
              },
              menuContainer: {
                backgroundColor: '#4471BE',
                borderBottom: '1px solid #1351B4'
              },
              servicosBtnActive: {
                backgroundColor: '#4471BE'
              },
              menuRight: {
                backgroundColor: '#5B82C5'
              },
              hover: {
                backgroundColor: '#5B82C5'
              },
              acessibilidade: {
                borderLeft: '1px solid '
              }
            },
          }

        },
        drawer: {
          SideMenu: {
            exitIcone: {
              color: '#FFFFFF'
            }
          }
        },
        newdashboard: {
          DashboardComBeneficio: {
            vermais: {
              color: '#1351b4'
            }
          },
          DashboardSemBeneficio: {
            vermais: {
              color: '#1351b4'
            }
          },
        }
      }

    },
    shared: {
      component: {
        NitContainer: {
          pointer: {
            color: '#1351B4'
          },
          container: {
            color: '#333333'
          }
        }
      },
      template: {
        AppTitleDesktop: {
          icoHome: {
            color: '#1351B4',
          },
          icoChevron: {
            color: '#333333',
          }
        },
        AppFooter: {
          footer: {
            backgroundColor: '#fff',
          }
        },
        Blockquote: {
          inlineError: {
            borderLeft: '5px solid #FF0000',
            backgroundColor: '#FFF0F0',
            color: '#333'
          },
          inlineWarning: {
            borderLeft: '5px solid #ffe564',
            backgroundColor: 'rgba(255,229,100,0.2)'
          },
          inlineInfo: {
            borderLeft: '5px solid #1351B4',
            backgroundColor: '#E9EFF7',
          },
          inlineSuccess: {
            borderLeft: '5px solid #168821',
            backgroundColor: '#e8f5e9',
          }
        },
        Card: {
          cover: {
            backgroundColor: '#f7faff',

          },
          card_title: {
            color: '#333333'
          },
          card_icon: {
            color: '#333333'
          }
        },
        CardWithIcon: {
          cover: {
            backgroundColor: '#f7faff',

          },
          card_title: {
            color: '#457dd1'
          },
          card_icon: {
            color: '#d6e5ff'

          }
        },
        CardButtonWithIconLeft: {
          card: {
            backgroundColor: "#fff",
          },
          content: {
            color: "#777",
          },
          icon: {
            color: "#1351B4",
          },
          text: {
            color: "#333333",
          },
        },
        GrupoDeDados: {
          card_title: {
            color: '#457dd1'
          }
        },
        InfoScreen: {
          container: {
            color: '#4d7aa1'
          },
          primaryText: {
            color: '#333333'
          },
          secondaryText: {
            color: '#333333'
          },
          card:{
            backgroundColor:'#fff'
          }
        },
        MeuINSSDescricao: {
          descricao: {
            color: '#333333'
          }
        },
        MeuInssLabelValue: {
          meu_inss_label: {
            color: '#333333'
          },
          meu_inss_value: {
            color: '#333333'
          }
        },
        MeuInssSubtitle: {
          value: {
            color: '#777'
          }
        },
        WhiteBox: {
          root: {
            backgroundColor: '#fff',
            border: '1px solid #E0E0E0'
          }
        },
      }
    },
    typography: {
      fontFamily: [
        'Rawline',
        'Rawline SemiBold',
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
      fontSize: fontSize,
      lineHeight: '60px',
    },
    props: {
      MuiButtonBase: {
        disableRipple: true,
      },
    },
    overrides: {
      MuiDialog: {
        root: {
          zIndex: 9999,
        },
      },
      MuiButton: {
        root: {
          background: 'transparent',
          border: '1px solid transparent',
          borderRadius: '100em',
          color: '#1351b4',
          height: '48px',
          lineHeight: '40px',
          fontSize: '14px',
          fontWeight: '600',
          margin: 'auto',
          width: 'auto',
          padding: '0px',
          textTransform: 'none',
          whiteSpace: 'nowrap',
          borderColor: '#1351B4'
        },
        text: {
          padding: '0px'
        },
        label: {
          marginLeft: '40px',
          marginRight: '40px'
        },
        textPrimary: {
          textDecoration: 'underline',
          '&:active': {
            boxShadow: 'none',
            background: '#071d41 !important',
            color: '#FFF !important'
          },
          '&:focus': {
            boxShadow: 'none',
            background: '#fff linear-gradient(rgba(242, 227, 23, 0.3), rgba(242, 227, 23, 0.3))',
          },
          '&:hover': {
            boxShadow: 'none',
            background: '#dbe8fb !important'
          },
        },
        contained: {
          boxShadow: 'none',
          '&:active': {
            boxShadow: 'none',
            background: '#071d41 !important',
            color: '#FFF !important'
          },
          '&:focus': {
            boxShadow: 'none',
            background: '#fff linear-gradient(rgba(242, 227, 23, 0.3), rgba(242, 227, 23, 0.3))',
          },
          '&:hover': {
            boxShadow: 'none',
            background: '#dbe8fb !important'
          },
          '&:disabled': {
            cursor: 'not-allowed',
            opacity: '0.5',
            pointerEvents: 'all',
            background: '#1351b4',
            color: '#fff',
            '&:hover': {
              background: '#1351b4 !important',
              color: '#fff',
            }
          },
        },
        containedPrimary: {
          background: '#1351b4',
          color: '#fff',
          '&:active': {
            color: '#fff',
          },
          '&:focus': {
            color: '#1351b4'
          },
          '&:hover': {
            color: '#1351b4',
          },
        },
        containedSecondary: {
          backgroundColor: 'transparent',
          borderColor: '#1351b4',
          color: '#1351b4'
        },
      },
      MuiFormLabel: {
        root: {
          color: "#333333",
        },
      },
      MuiIconButton: {
        root: {
          color: '#1351b4',  
        }
      },  
      MuiList: {
        root: {
          backgroundColor: '#FFFFFF'
        }
      },
      MuiListItemSecondaryAction: {
        root: {
          color: '#1351b4',
          fontSize: '1.728em',
          height: '100%',
          display: "flex",
          alignItems: 'center'
        }
      },
      MuiListItem: {
        root: {
          backgroundColor: '#FFFFFF'
        },
        button: {
          '&:hover': {
            backgroundColor: 'transparent'
          }
        }
      },
      MuiSwitch: {
        thumb: {
          border: '1px solid #888',
          color: '#fff'
        },
        colorSecondary: {
          '&.Mui-checked': {
            '& + .MuiSwitch-track': {
              backgroundColor: '#5e92f3',
              opacity: "1"
            }
          }        
        }
      },       
      MuiSvgIcon: {
        root: {
          fontSize: '1.728em'
        }
      },  
      MuiTypography: {
        body1: {
          fontSize: "inherit"
        },
        subtitle1: {
          textTransform: "none",
        }
      }, 
      ServicosRecomendados: {
        backgroundColor: '#f8f8f8 !important'
      },
      AjudaHelo: {
        backgroundColor: '#F0F0F0',
        color: '#000',
        buttonColor: '#1351b4'
      }
    },
  });
}
